const options = {
  unity: {
    1706: '61 Promoções e eventos'
  },
  gender: [
    {
      value: 0,
      label: 'Feminino'
    },
    {
      value: 1,
      label: 'Masculino'
    }
  ],
  ethnicity: {
    82: 'Oriente Médio / Norte Africano',
    83: 'Africano',
    84: 'Nativo Americano',
    85: 'Indiano',
    86: 'Latino Americano/Hispanico',
    87: 'Latino Americano/Moreno',
    88: 'Latinoamericano/Moreno Claro',
    89: 'Latino Americano/International',
    90: 'Asiático',
    91: 'Caucasiano/Europeus',
    92: 'Caucasiano / Loiro',
    93: 'Indígena',
    94: 'Mestiço',
    95: 'Polinésio'
  },
  nationality: {
    1: 'Afghanistan',
    2: 'Albania',
    3: 'Algeria',
    4: 'Andorra',
    5: 'Angola',
    6: 'Argentina',
    7: 'Armenia',
    8: 'Australia',
    9: 'Austria',
    10: 'Azerbaijan',
    11: 'Bahrain',
    12: 'Bangladesh',
    13: 'Barbados',
    14: 'Belarus',
    15: 'Belgium',
    16: 'Belize',
    17: 'Benin',
    18: 'Bhutan',
    19: 'Bolivia',
    20: 'Bosnia and Herzegovina',
    21: 'Brazil',
    22: 'Brunei',
    23: 'Bulgaria',
    24: 'Cambodia',
    25: 'Cameroon',
    26: 'Canada',
    27: 'Cape Verde',
    28: 'Central African Republic',
    29: 'Chad',
    30: 'Chile',
    31: 'China',
    32: 'Colombia',
    33: 'Comoros',
    34: 'Costa Rica',
    35: 'Croatia',
    36: 'Cuba',
    37: 'Cyprus',
    38: 'Czech Republic',
    39: 'Denmark',
    40: 'Djibouti',
    41: 'Ecuador',
    42: 'El Salvador',
    43: 'Equatorial Guinea',
    44: 'Eritrea',
    45: 'Estonia',
    46: 'Ethiopia',
    47: 'Fiji',
    48: 'Finland',
    49: 'France',
    50: 'Gabon',
    51: 'Gambia',
    52: 'Georgia',
    53: 'Germany',
    54: 'Ghana',
    55: 'Greece',
    56: 'Grenada',
    57: 'Guatemala',
    58: 'Guyana',
    59: 'Haiti',
    60: 'Honduras',
    61: 'Hungary',
    62: 'Iceland',
    63: 'India',
    64: 'Indonesia',
    65: 'Iran',
    66: 'Iraq',
    67: 'Ireland',
    68: 'Israel',
    69: 'Italy',
    70: 'Jamaica',
    71: 'Japan',
    72: 'Jordan',
    73: 'Kazakhstan',
    74: 'Kenya',
    75: 'Kiribati',
    76: 'South Korea',
    77: 'Kuwait',
    78: 'Latvia',
    79: 'Lebanon',
    80: 'Liberia',
    81: 'Libya',
    82: 'Liechtenstein',
    83: 'Lithuania',
    84: 'Luxembourg',
    85: 'Macedonia',
    86: 'Malawi',
    87: 'Malaysia',
    88: 'Maldives',
    89: 'Mali',
    90: 'Malta',
    91: 'Marshall Islands',
    92: 'Mauritania',
    93: 'Mauritius',
    94: 'Mexico',
    95: 'Micronesia',
    96: 'Moldova',
    97: 'Monaco',
    98: 'Morocco',
    99: 'Mozambique',
    100: 'Myanmar',
    101: 'Nepal',
    102: 'Netherlands',
    103: 'New Zealand',
    104: 'Nicaragua',
    105: 'Niger',
    106: 'Nigeria',
    107: 'Norway',
    108: 'Oman',
    109: 'Pakistan',
    110: 'Palau',
    111: 'Panama',
    112: 'Papua New Guinea',
    113: 'Paraguay',
    114: 'Peru',
    115: 'Philippines',
    116: 'Poland',
    117: 'Portugal',
    118: 'Qatar',
    119: 'Romania',
    120: 'Russia',
    121: 'Saint Kitts and Nevis',
    122: 'Samoa',
    123: 'Sao Tome and Principe',
    124: 'Senegal',
    125: 'Seychelles',
    126: 'Singapore',
    127: 'Slovenia',
    128: 'Solomon Islands',
    129: 'Somalia',
    130: 'South Africa',
    131: 'Spain',
    132: 'Sri Lanka',
    133: 'Sudan',
    134: 'Suriname',
    135: 'Swaziland',
    136: 'Sweden',
    137: 'Switzerland',
    138: 'Syria',
    139: 'Taiwan',
    140: 'Tajikistan',
    141: 'Tanzania',
    142: 'Thailand',
    143: 'Togo',
    144: 'Tonga',
    145: 'Tunisia',
    146: 'Turkey',
    147: 'Tuvalu',
    148: 'Uganda',
    149: 'Ukraine',
    150: 'United Kingdom',
    151: 'United States',
    152: 'Uruguay',
    153: 'Venezuela',
    154: 'Vietnam',
    155: 'Yemen',
    156: 'Zambia',
    157: 'Zimbabwe',
    158: 'North Korea',
    159: 'United Arab Emirates',
    160: 'Aruba',
    161: 'Botswana',
    162: 'Burkina Faso',
    163: 'Burundi',
    164: 'Congo',
    165: 'Cook Islands',
    166: 'Democratic Republic of Congo',
    167: 'Egypt',
    168: 'Falkland (Malvinas) Islands',
    169: 'Faroe Islands',
    170: 'French Guiana',
    171: 'French Polynesia',
    172: 'Gibraltar',
    173: 'Greenland',
    174: 'Guadeloupe',
    175: 'Guinea',
    176: 'Guinea-Bissau',
    177: 'Hong Kong',
    178: 'Ivory Coast',
    179: 'Kyrgyzstan',
    180: 'Laos',
    181: 'Lesotho',
    182: 'Macau',
    183: 'Madagascar',
    184: 'Martinique',
    185: 'Reunion',
    186: 'Mongolia',
    187: 'Montenegro',
    188: 'Namibia',
    189: 'Nauru',
    190: 'Netherlands Antilles',
    191: 'New Caledonia',
    192: 'Niue Island',
    193: 'Rwanda',
    194: 'San Marino',
    195: 'Saudi Arabia',
    196: 'Serbia',
    197: 'Sierra Leone',
    198: 'Slovakia',
    199: 'Tokelau',
    200: 'Turkmenistan',
    201: 'Uzbekistan',
    202: 'Vanuatu',
    203: 'Vatican City',
    204: 'Wallis and Futuna',
    205: 'Saint Helena',
    206: 'Saint Pierre and Miquelon',
    207: 'East Timor',
    208: 'U.S. Virgin Islands',
    209: 'Porto Rico',
    210: 'Dominican Republic',
    211: 'ZZ',
    212: 'England'
  },
  langs: {
    96: 'AF',
    97: 'SQ',
    98: 'AR',
    99: 'HY',
    100: 'EU',
    101: 'BN',
    102: 'BG',
    103: 'CA',
    104: 'KM',
    105: 'ZH',
    106: 'HR',
    107: 'CS',
    108: 'DA',
    109: 'NL',
    110: 'EN',
    111: 'ET',
    112: 'FJ',
    113: 'FI',
    114: 'FR',
    115: 'KA',
    116: 'DE',
    117: 'EL',
    118: 'GU',
    119: 'HE',
    120: 'HI',
    121: 'HU',
    122: 'IS',
    123: 'ID',
    124: 'GA',
    125: 'IT',
    126: 'JA',
    127: 'JW',
    128: 'KO',
    129: 'LA',
    130: 'LV',
    131: 'LT',
    132: 'MK',
    133: 'MS',
    134: 'ML',
    135: 'MT',
    136: 'MI',
    137: 'MR',
    138: 'MN',
    139: 'NE',
    140: 'NO',
    141: 'FA',
    142: 'PL',
    143: 'PT',
    144: 'PA',
    145: 'QU',
    146: 'RO',
    147: 'RU',
    148: 'SM',
    149: 'SR',
    150: 'SK',
    151: 'SL',
    152: 'ES',
    153: 'SW',
    154: 'SV',
    155: 'TA',
    156: 'TT',
    157: 'TE',
    158: 'TH',
    159: 'BO',
    160: 'TO',
    161: 'TR',
    162: 'UK',
    163: 'UR',
    164: 'UZ',
    165: 'VI',
    166: 'CY',
    167: 'XH',
    168: 'ZU',
    643: 'LB'
  },
  translate_langs: {
    en: [
      { value: 'AF', label: 'Africâner' },
      { value: 'SQ', label: 'Albanês' },
      { value: 'AR', label: 'Árabe' },
      { value: 'HY', label: 'Armênio' },
      { value: 'UE', label: 'Basco' },
      { value: 'BN', label: 'Bengalês' },
      { value: 'BG', label: 'Búlgaro' },
      { value: 'CA', label: 'Catalão' },
      { value: 'KM', label: 'Cambojano' },
      { value: 'ZH', label: 'Chinês' },
      { value: 'HR', label: 'Croata' },
      { value: 'CS', label: 'Tcheco' },
      { value: 'DA', label: 'Dinamarquês' },
      { value: 'NL', label: 'holandês' },
      { value: 'EN', label: 'Inglês' },
      { value: 'ET', label: 'Estoniano' },
      { value: 'FJ', label: 'Fijiano' },
      { value: 'FI', label: 'Finlandês' },
      { value: 'FR', label: 'Francês' },
      { value: 'KA', label: 'Georgiano' },
      { value: 'DE', label: 'Alemão' },
      { value: 'EL', label: 'Grego' },
      { value: 'GU', label: 'Gujarati' },
      { value: 'HE', label: 'Hebraico' },
      { value: 'HI', label: 'Hindi' },
      { value: 'HU', label: 'Húngaro' },
      { value: 'IS', label: 'Islandês' },
      { value: 'ID', label: 'Indonésio' },
      { value: 'GA', label: 'Irlandês' },
      { value: 'IT', label: 'Italiano' },
      { value: 'JA', label: 'Japonês' },
      { value: 'JW', label: 'Javanês' },
      { value: 'KO', label: 'Coreano' },
      { value: 'LA', label: 'Latim' },
      { value: 'LV', label: 'Letão' },
      { value: 'LB', label: 'Libra' },
      { value: 'LT', label: 'Lituano' },
      { value: 'MK', label: 'Macedônio' },
      { value: 'MS', label: 'Malaio' },
      { value: 'ML', label: 'Malaiala' },
      { value: 'MT', label: 'Maltês' },
      { value: 'MI', label: 'Maori' },
      { value: 'MR', label: 'Marata' },
      { value: 'MN', label: 'Mongol' },
      { value: 'ZA_NS', label: 'Ndebele' },
      { value: 'NE', label: 'Nepali' },
      { value: 'ST_NS', label: 'Soto do Norte' },
      { value: 'NO', label: 'Norueguês' },
      { value: 'FA', label: 'Persa' },
      { value: 'PL', label: 'Polonês' },
      { value: 'PT', label: 'Português' },
      { value: 'PA', label: 'Punjabi' },
      { value: 'QU', label: 'Quechua' },
      { value: 'RO', label: 'Romeno' },
      { value: 'RU', label: 'Russo' },
      { value: 'SM', label: 'Samoano' },
      { value: 'SR', label: 'Sérvio' },
      { value: 'SK', label: 'Eslovaco' },
      { value: 'SL', label: 'Esloveno' },
      { value: 'ST', label: 'Soto' },
      { value: 'ES', label: 'Espanhol' },
      { value: 'SW', label: 'Suaíli' },
      { value: 'SS', label: 'Suázi' },
      { value: 'SV', label: 'Sueco' },
      { value: 'TA', label: 'Tâmil' },
      { value: 'TT', label: 'Tártara' },
      { value: 'TE', label: 'Telugu' },
      { value: 'TH', label: 'Tailandês' },
      { value: 'BO', label: 'Tibetano' },
      { value: 'TO', label: 'Tonga' },
      { value: 'TS', label: 'Tsonga' },
      { value: 'TN', label: 'Tswana' },
      { value: 'TR', label: 'Turco' },
      { value: 'UK', label: 'Ucrâniano' },
      { value: 'UR', label: 'Urdu' },
      { value: 'UZ', label: 'Uzbeque' },
      { value: 'VE', label: 'Venda' },
      { value: 'VI', label: 'Vietnamita' },
      { value: 'CY', label: 'Galês' },
      { value: 'XH', label: 'Xhosa' },
      { value: 'ZU', label: 'Zulu' }
    ]
  },
  translate_langs_check: {
    en: {
      AF: 'Afrikaans',
      SQ: 'Albanian',
      AR: 'Arabic',
      HY: 'Armenian',
      EU: 'Basque',
      BN: 'Bengali',
      BG: 'Bulgarian',
      CA: 'Catalan',
      KM: 'Cambodian',
      ZH: 'Chinese ',
      HR: 'Croation',
      CS: 'Czech',
      DA: 'Danish',
      NL: 'Dutch',
      EN: 'English',
      ET: 'Estonian',
      FJ: 'Fiji',
      FI: 'Finnish',
      FR: 'French',
      KA: 'Georgian',
      DE: 'German',
      EL: 'Greek',
      GU: 'Gujarati',
      HE: 'Hebrew',
      HI: 'Hindi',
      HU: 'Hungarian',
      IS: 'Icelandic',
      ID: 'Indonesian',
      GA: 'Irish',
      IT: 'Italian',
      JA: 'Japanese',
      JW: 'Javanese',
      KO: 'Korean',
      LA: 'Latin',
      LV: 'Latvian',
      LB: 'Libra',
      LT: 'Lithuanian',
      MK: 'Macedonian',
      MS: 'Malay',
      ML: 'Malayalam',
      MT: 'Maltese',
      MI: 'Maori',
      MR: 'Marathi',
      MN: 'Mongolian',
      ZA_NS: 'Ndebele',
      NE: 'Nepali',
      ST_NS: 'Northern Sotho',
      NO: 'Norwegian',
      FA: 'Persian',
      PL: 'Polish',
      PT: 'Portuguese',
      PA: 'Punjabi',
      QU: 'Quechua',
      RO: 'Romanian',
      RU: 'Russian',
      SM: 'Samoan',
      SR: 'Serbian',
      SK: 'Slovak',
      SL: 'Slovenian',
      ST: 'Sotho',
      ES: 'Spanish',
      SW: 'Swahili',
      SS: 'Swati',
      SV: 'Swedish ',
      TA: 'Tamil',
      TT: 'Tatar',
      TE: 'Telugu',
      TH: 'Thai',
      BO: 'Tibetan',
      TO: 'Tonga',
      TS: 'Tsonga',
      TN: 'Tswana',
      TR: 'Turkish',
      UK: 'Ukranian',
      UR: 'Urdu',
      UZ: 'Uzbek',
      VE: 'Venda',
      VI: 'Vietnamese',
      CY: 'Welsh',
      XH: 'Xhosa',
      ZU: 'Zulu'
    }
  },
  height: [
    { value: '30/1.0', label: "30cm / 1'0\"" },
    { value: '31/1.0', label: "31cm / 1'0\"" },
    { value: '32/1.1', label: "32cm / 1'1\"" },
    { value: '33/1.1', label: "33cm / 1'1\"" },
    { value: '34/1.1', label: "34cm / 1'1\"" },
    { value: '35/1.2', label: "35cm / 1'2\"" },
    { value: '36/1.2', label: "36cm / 1'2\"" },
    { value: '37/1.3', label: "37cm / 1'3\"" },
    { value: '38/1.3', label: "38cm / 1'3\"" },
    { value: '39/1.3', label: "39cm / 1'3\"" },
    { value: '40/1.4', label: "40cm / 1'4\"" },
    { value: '41/1.4', label: "41cm / 1'4\"" },
    { value: '42/1.5', label: "42cm / 1'5\"" },
    { value: '43/1.5', label: "43cm / 1'5\"" },
    { value: '44/1.5', label: "44cm / 1'5\"" },
    { value: '45/1.6', label: "45cm / 1'6\"" },
    { value: '46/1.6', label: "46cm / 1'6\"" },
    { value: '47/1.7', label: "47cm / 1'7\"" },
    { value: '48/1.7', label: "48cm / 1'7\"" },
    { value: '49/1.7', label: "49cm / 1'7\"" },
    { value: '50/1.8', label: "50cm / 1'8\"" },
    { value: '51/1.8', label: "51cm / 1'8\"" },
    { value: '52/1.8', label: "52cm / 1'8\"" },
    { value: '53/1.9', label: "53cm / 1'9\"" },
    { value: '54/1.9', label: "54cm / 1'9\"" },
    { value: '55/1.10', label: "55cm / 1'10\"" },
    { value: '56/1.10', label: "56cm / 1'10\"" },
    { value: '57/1.10', label: "57cm / 1'10\"" },
    { value: '58/1.11', label: "58cm / 1'11\"" },
    { value: '59/1.11', label: "59cm / 1'11\"" },
    { value: '60/2.0', label: "60cm / 2'0\"" },
    { value: '61/2.0', label: "61cm / 2'0\"" },
    { value: '62/2.0', label: "62cm / 2'0\"" },
    { value: '63/2.1', label: "63cm / 2'1\"" },
    { value: '64/2.1', label: "64cm / 2'1\"" },
    { value: '65/2.2', label: "65cm / 2'2\"" },
    { value: '66/2.2', label: "66cm / 2'2\"" },
    { value: '67/2.2', label: "67cm / 2'2\"" },
    { value: '68/2.3', label: "68cm / 2'3\"" },
    { value: '69/2.3', label: "69cm / 2'3\"" },
    { value: '70/2.4', label: "70cm / 2'4\"" },
    { value: '71/2.4', label: "71cm / 2'4\"" },
    { value: '72/2.4', label: "72cm / 2'4\"" },
    { value: '73/2.5', label: "73cm / 2'5\"" },
    { value: '74/2.5', label: "74cm / 2'5\"" },
    { value: '75/2.6', label: "75cm / 2'6\"" },
    { value: '76/2.6', label: "76cm / 2'6\"" },
    { value: '77/2.6', label: "77cm / 2'6\"" },
    { value: '78/2.7', label: "78cm / 2'7\"" },
    { value: '79/2.7', label: "79cm / 2'7\"" },
    { value: '80/2.7', label: "80cm / 2'7\"" },
    { value: '81/2.8', label: "81cm / 2'8\"" },
    { value: '82/2.8', label: "82cm / 2'8\"" },
    { value: '83/2.9', label: "83cm / 2'9\"" },
    { value: '84/2.9', label: "84cm / 2'9\"" },
    { value: '85/2.9', label: "85cm / 2'9\"" },
    { value: '86/2.10', label: "86cm / 2'10\"" },
    { value: '87/2.10', label: "87cm / 2'10\"" },
    { value: '88/2.11', label: "88cm / 2'11\"" },
    { value: '89/2.11', label: "89cm / 2'11\"" },
    { value: '90/2.11', label: "90cm / 2'11\"" },
    { value: '91/3.0', label: "91cm / 3'0\"" },
    { value: '92/3.0', label: "92cm / 3'0\"" },
    { value: '93/3.1', label: "93cm / 3'1\"" },
    { value: '94/3.1', label: "94cm / 3'1\"" },
    { value: '95/3.1', label: "95cm / 3'1\"" },
    { value: '96/3.2', label: "96cm / 3'2\"" },
    { value: '97/3.2', label: "97cm / 3'2\"" },
    { value: '98/3.3', label: "98cm / 3'3\"" },
    { value: '99/3.3', label: "99cm / 3'3\"" },
    { value: '100/3.3', label: "100cm / 3'3\"" },
    { value: '101/3.4', label: "101cm / 3'4\"" },
    { value: '102/3.4', label: "102cm / 3'4\"" },
    { value: '103/3.5', label: "103cm / 3'5\"" },
    { value: '104/3.5', label: "104cm / 3'5\"" },
    { value: '105/3.5', label: "105cm / 3'5\"" },
    { value: '106/3.6', label: "106cm / 3'6\"" },
    { value: '107/3.6', label: "107cm / 3'6\"" },
    { value: '108/3.7', label: "108cm / 3'7\"" },
    { value: '109/3.7', label: "109cm / 3'7\"" },
    { value: '110/3.7', label: "110cm / 3'7\"" },
    { value: '111/3.8', label: "111cm / 3'8\"" },
    { value: '112/3.8', label: "112cm / 3'8\"" },
    { value: '113/3.8', label: "113cm / 3'8\"" },
    { value: '114/3.9', label: "114cm / 3'9\"" },
    { value: '115/3.9', label: "115cm / 3'9\"" },
    { value: '116/3.10', label: "116cm / 3'10\"" },
    { value: '117/3.10', label: "117cm / 3'10\"" },
    { value: '118/3.10', label: "118cm / 3'10\"" },
    { value: '119/3.11', label: "119cm / 3'11\"" },
    { value: '120/3.11', label: "120cm / 3'11\"" },
    { value: '121/4.0', label: "121cm / 4'0\"" },
    { value: '122/4.0', label: "122cm / 4'0\"" },
    { value: '123/4.0', label: "123cm / 4'0\"" },
    { value: '124/4.1', label: "124cm / 4'1\"" },
    { value: '125/4.1', label: "125cm / 4'1\"" },
    { value: '126/4.2', label: "126cm / 4'2\"" },
    { value: '127/4.2', label: "127cm / 4'2\"" },
    { value: '128/4.2', label: "128cm / 4'2\"" },
    { value: '129/4.3', label: "129cm / 4'3\"" },
    { value: '130/4.3', label: "130cm / 4'3\"" },
    { value: '131/4.4', label: "131cm / 4'4\"" },
    { value: '132/4.4', label: "132cm / 4'4\"" },
    { value: '133/4.4', label: "133cm / 4'4\"" },
    { value: '134/4.5', label: "134cm / 4'5\"" },
    { value: '135/4.5', label: "135cm / 4'5\"" },
    { value: '136/4.6', label: "136cm / 4'6\"" },
    { value: '137/4.6', label: "137cm / 4'6\"" },
    { value: '138/4.6', label: "138cm / 4'6\"" },
    { value: '139/4.7', label: "139cm / 4'7\"" },
    { value: '140/4.7', label: "140cm / 4'7\"" },
    { value: '141/4.8', label: "141cm / 4'8\"" },
    { value: '142/4.8', label: "142cm / 4'8\"" },
    { value: '143/4.8', label: "143cm / 4'8\"" },
    { value: '144/4.9', label: "144cm / 4'9\"" },
    { value: '145/4.9', label: "145cm / 4'9\"" },
    { value: '146/4.9', label: "146cm / 4'9\"" },
    { value: '147/4.10', label: "147cm / 4'10\"" },
    { value: '148/4.10', label: "148cm / 4'10\"" },
    { value: '149/4.11', label: "149cm / 4'11\"" },
    { value: '150/4.11', label: "150cm / 4'11\"" },
    { value: '151/4.11', label: "151cm / 4'11\"" },
    { value: '152/5.0', label: "152cm / 5'0\"" },
    { value: '153/5.0', label: "153cm / 5'0\"" },
    { value: '154/5.1', label: "154cm / 5'1\"" },
    { value: '155/5.1', label: "155cm / 5'1\"" },
    { value: '156/5.1', label: "156cm / 5'1\"" },
    { value: '157/5.2', label: "157cm / 5'2\"" },
    { value: '158/5.2', label: "158cm / 5'2\"" },
    { value: '159/5.3', label: "159cm / 5'3\"" },
    { value: '160/5.3', label: "160cm / 5'3\"" },
    { value: '161/5.3', label: "161cm / 5'3\"" },
    { value: '162/5.4', label: "162cm / 5'4\"" },
    { value: '163/5.4', label: "163cm / 5'4\"" },
    { value: '164/5.5', label: "164cm / 5'5\"" },
    { value: '165/5.5', label: "165cm / 5'5\"" },
    { value: '166/5.5', label: "166cm / 5'5\"" },
    { value: '167/5.6', label: "167cm / 5'6\"" },
    { value: '168/5.6', label: "168cm / 5'6\"" },
    { value: '169/5.7', label: "169cm / 5'7\"" },
    { value: '170/5.7', label: "170cm / 5'7\"" },
    { value: '171/5.7', label: "171cm / 5'7\"" },
    { value: '172/5.8', label: "172cm / 5'8\"" },
    { value: '173/5.8', label: "173cm / 5'8\"" },
    { value: '174/5.9', label: "174cm / 5'9\"" },
    { value: '175/5.9', label: "175cm / 5'9\"" },
    { value: '176/5.9', label: "176cm / 5'9\"" },
    { value: '177/5.10', label: "177cm / 5'10\"" },
    { value: '178/5.10', label: "178cm / 5'10\"" },
    { value: '179/5.10', label: "179cm / 5'10\"" },
    { value: '180/5.11', label: "180cm / 5'11\"" },
    { value: '181/5.11', label: "181cm / 5'11\"" },
    { value: '182/6.0', label: "182cm / 6'0\"" },
    { value: '183/6.0', label: "183cm / 6'0\"" },
    { value: '184/6.0', label: "184cm / 6'0\"" },
    { value: '185/6.1', label: "185cm / 6'1\"" },
    { value: '186/6.1', label: "186cm / 6'1\"" },
    { value: '187/6.2', label: "187cm / 6'2\"" },
    { value: '188/6.2', label: "188cm / 6'2\"" },
    { value: '189/6.2', label: "189cm / 6'2\"" },
    { value: '190/6.3', label: "190cm / 6'3\"" },
    { value: '191/6.3', label: "191cm / 6'3\"" },
    { value: '192/6.4', label: "192cm / 6'4\"" },
    { value: '193/6.4', label: "193cm / 6'4\"" },
    { value: '194/6.4', label: "194cm / 6'4\"" },
    { value: '195/6.5', label: "195cm / 6'5\"" },
    { value: '196/6.5', label: "196cm / 6'5\"" },
    { value: '197/6.6', label: "197cm / 6'6\"" },
    { value: '198/6.6', label: "198cm / 6'6\"" },
    { value: '199/6.6', label: "199cm / 6'6\"" },
    { value: '200/6.7', label: "200cm / 6'7\"" }
  ],
  bust: [
    { value: '65/25.6', label: '65cm / 25.6"' },
    { value: '66/26', label: '66cm / 26"' },
    { value: '67/26.4', label: '67cm / 26.4"' },
    { value: '68/26.8', label: '68cm / 26.8"' },
    { value: '69/27.2', label: '69cm / 27.2"' },
    { value: '70/27.6', label: '70cm / 27.6"' },
    { value: '71/28', label: '71cm / 28"' },
    { value: '72/28.3', label: '72cm / 28.3"' },
    { value: '73/28.7', label: '73cm / 28.7"' },
    { value: '74/29.1', label: '74cm / 29.1"' },
    { value: '75/29.5', label: '75cm / 29.5"' },
    { value: '76/29.9', label: '76cm / 29.9"' },
    { value: '77/30.3', label: '77cm / 30.3"' },
    { value: '78/30.7', label: '78cm / 30.7"' },
    { value: '79/31.1', label: '79cm / 31.1"' },
    { value: '80/31.5', label: '80cm / 31.5"' },
    { value: '81/31.9', label: '81cm / 31.9"' },
    { value: '82/32.3', label: '82cm / 32.3"' },
    { value: '83/32.7', label: '83cm / 32.7"' },
    { value: '84/33.1', label: '84cm / 33.1"' },
    { value: '85/33.5', label: '85cm / 33.5"' },
    { value: '86/33.9', label: '86cm / 33.9"' },
    { value: '87/34.3', label: '87cm / 34.3"' },
    { value: '88/34.6', label: '88cm / 34.6"' },
    { value: '89/35', label: '89cm / 35"' },
    { value: '90/35.4', label: '90cm / 35.4"' },
    { value: '91/35.8', label: '91cm / 35.8"' },
    { value: '92/36.2', label: '92cm / 36.2"' },
    { value: '93/36.6', label: '93cm / 36.6"' },
    { value: '94/37', label: '94cm / 37"' },
    { value: '95/37.4', label: '95cm / 37.4"' },
    { value: '96/37.8', label: '96cm / 37.8"' },
    { value: '97/38.2', label: '97cm / 38.2"' },
    { value: '98/38.6', label: '98cm / 38.6"' },
    { value: '99/39', label: '99cm / 39"' },
    { value: '100/39.4', label: '100cm / 39.4"' },
    { value: '101/39.8', label: '101cm / 39.8"' },
    { value: '102/40.2', label: '102cm / 40.2"' },
    { value: '103/40.6', label: '103cm / 40.6"' },
    { value: '104/40.9', label: '104cm / 40.9"' },
    { value: '105/41.3', label: '105cm / 41.3"' },
    { value: '106/41.7', label: '106cm / 41.7"' },
    { value: '107/42.1', label: '107cm / 42.1"' },
    { value: '108/42.5', label: '108cm / 42.5"' },
    { value: '109/42.9', label: '109cm / 42.9"' },
    { value: '110/43.3', label: '110cm / 43.3"' },
    { value: '111/43.7', label: '111cm / 43.7"' },
    { value: '112/44.1', label: '112cm / 44.1"' },
    { value: '113/44.5', label: '113cm / 44.5"' },
    { value: '114/44.9', label: '114cm / 44.9"' },
    { value: '115/45.3', label: '115cm / 45.3"' },
    { value: '116/45.7', label: '116cm / 45.7"' },
    { value: '117/46.1', label: '117cm / 46.1"' },
    { value: '118/46.5', label: '118cm / 46.5"' },
    { value: '119/46.9', label: '119cm / 46.9"' },
    { value: '120/47.2', label: '120cm / 47.2"' },
    { value: '121/47.6', label: '121cm / 47.6"' },
    { value: '122/48', label: '122cm / 48"' },
    { value: '123/48.4', label: '123cm / 48.4"' },
    { value: '124/48.8', label: '124cm / 48.8"' },
    { value: '125/49.2', label: '125cm / 49.2"' },
    { value: '126/49.6', label: '126cm / 49.6"' },
    { value: '127/50', label: '127cm / 50"' },
    { value: '128/50.4', label: '128cm / 50.4"' },
    { value: '129/50.8', label: '129cm / 50.8"' },
    { value: '130/51.2', label: '130cm / 51.2"' },
    { value: '131/51.6', label: '131cm / 51.6"' },
    { value: '132/52', label: '132cm / 52"' },
    { value: '133/52.4', label: '133cm / 52.4"' },
    { value: '134/52.8', label: '134cm / 52.8"' },
    { value: '135/53.1', label: '135cm / 53.1"' },
    { value: '136/53.5', label: '136cm / 53.5"' },
    { value: '137/53.9', label: '137cm / 53.9"' },
    { value: '138/54.3', label: '138cm / 54.3"' },
    { value: '139/54.7', label: '139cm / 54.7"' },
    { value: '140/55.1', label: '140cm / 55.1"' },
    { value: '141/55.5', label: '141cm / 55.5"' },
    { value: '142/55.9', label: '142cm / 55.9"' },
    { value: '143/56.3', label: '143cm / 56.3"' },
    { value: '144/56.7', label: '144cm / 56.7"' },
    { value: '145/57.1', label: '145cm / 57.1"' },
    { value: '146/57.5', label: '146cm / 57.5"' },
    { value: '147/57.9', label: '147cm / 57.9"' },
    { value: '148/58.3', label: '148cm / 58.3"' },
    { value: '149/58.7', label: '149cm / 58.7"' },
    { value: '150/59.1', label: '150cm / 59.1"' },
    { value: '151/59.4', label: '151cm / 59.4"' },
    { value: '152/59.8', label: '152cm / 59.8"' },
    { value: '153/60.2', label: '153cm / 60.2"' },
    { value: '154/60.6', label: '154cm / 60.6"' },
    { value: '155/61', label: '155cm / 61"' },
    { value: '156/61.4', label: '156cm / 61.4"' },
    { value: '157/61.8', label: '157cm / 61.8"' },
    { value: '158/62.2', label: '158cm / 62.2"' },
    { value: '159/62.6', label: '159cm / 62.6"' },
    { value: '160/63', label: '160cm / 63"' },
    { value: '161/63.4', label: '161cm / 63.4"' },
    { value: '162/63.8', label: '162cm / 63.8"' },
    { value: '163/64.2', label: '163cm / 64.2"' },
    { value: '164/64.6', label: '164cm / 64.6"' },
    { value: '165/65', label: '165cm / 65"' },
    { value: '166/65.4', label: '166cm / 65.4"' },
    { value: '167/65.7', label: '167cm / 65.7"' },
    { value: '168/66.1', label: '168cm / 66.1"' },
    { value: '169/66.5', label: '169cm / 66.5"' },
    { value: '170/66.9', label: '170cm / 66.9"' },
    { value: '171/67.3', label: '171cm / 67.3"' },
    { value: '172/67.7', label: '172cm / 67.7"' },
    { value: '173/68.1', label: '173cm / 68.1"' },
    { value: '174/68.5', label: '174cm / 68.5"' },
    { value: '175/68.9', label: '175cm / 68.9"' },
    { value: '176/69.3', label: '176cm / 69.3"' },
    { value: '177/69.7', label: '177cm / 69.7"' },
    { value: '178/70.1', label: '178cm / 70.1"' },
    { value: '179/70.5', label: '179cm / 70.5"' },
    { value: '180/70.9', label: '180cm / 70.9"' },
    { value: '181/71.3', label: '181cm / 71.3"' },
    { value: '182/71.7', label: '182cm / 71.7"' },
    { value: '183/72', label: '183cm / 72"' },
    { value: '184/72.4', label: '184cm / 72.4"' },
    { value: '185/72.8', label: '185cm / 72.8"' },
    { value: '186/73.2', label: '186cm / 73.2"' },
    { value: '187/73.6', label: '187cm / 73.6"' },
    { value: '188/74', label: '188cm / 74"' },
    { value: '189/74.4', label: '189cm / 74.4"' },
    { value: '190/74.8', label: '190cm / 74.8"' },
    { value: '191/75.2', label: '191cm / 75.2"' },
    { value: '192/75.6', label: '192cm / 75.6"' },
    { value: '193/76', label: '193cm / 76"' },
    { value: '194/76.4', label: '194cm / 76.4"' },
    { value: '195/76.8', label: '195cm / 76.8"' },
    { value: '196/77.2', label: '196cm / 77.2"' },
    { value: '197/77.6', label: '197cm / 77.6"' },
    { value: '198/78', label: '198cm / 78"' },
    { value: '199/78.3', label: '199cm / 78.3"' },
    { value: '200/78.7', label: '200cm / 78.7"' }
  ],
  waist: [
    { value: '20/7.9', label: '20cm / 7.9"' },
    { value: '21/8.3', label: '21cm / 8.3"' },
    { value: '22/8.7', label: '22cm / 8.7"' },
    { value: '23/9.1', label: '23cm / 9.1"' },
    { value: '24/9.4', label: '24cm / 9.4"' },
    { value: '25/9.8', label: '25cm / 9.8"' },
    { value: '26/10.2', label: '26cm / 10.2"' },
    { value: '27/10.6', label: '27cm / 10.6"' },
    { value: '28/11', label: '28cm / 11"' },
    { value: '29/11.4', label: '29cm / 11.4"' },
    { value: '30/11.8', label: '30cm / 11.8"' },
    { value: '31/12.2', label: '31cm / 12.2"' },
    { value: '32/12.6', label: '32cm / 12.6"' },
    { value: '33/13', label: '33cm / 13"' },
    { value: '34/13.4', label: '34cm / 13.4"' },
    { value: '35/13.8', label: '35cm / 13.8"' },
    { value: '36/14.2', label: '36cm / 14.2"' },
    { value: '37/14.6', label: '37cm / 14.6"' },
    { value: '38/15', label: '38cm / 15"' },
    { value: '39/15.4', label: '39cm / 15.4"' },
    { value: '40/15.7', label: '40cm / 15.7"' },
    { value: '41/16.1', label: '41cm / 16.1"' },
    { value: '42/16.5', label: '42cm / 16.5"' },
    { value: '43/16.9', label: '43cm / 16.9"' },
    { value: '44/17.3', label: '44cm / 17.3"' },
    { value: '45/17.7', label: '45cm / 17.7"' },
    { value: '46/18.1', label: '46cm / 18.1"' },
    { value: '47/18.5', label: '47cm / 18.5"' },
    { value: '48/18.9', label: '48cm / 18.9"' },
    { value: '49/19.3', label: '49cm / 19.3"' },
    { value: '50/19.7', label: '50cm / 19.7"' },
    { value: '51/20.1', label: '51cm / 20.1"' },
    { value: '52/20.5', label: '52cm / 20.5"' },
    { value: '53/20.9', label: '53cm / 20.9"' },
    { value: '54/21.3', label: '54cm / 21.3"' },
    { value: '55/21.7', label: '55cm / 21.7"' },
    { value: '56/22', label: '56cm / 22"' },
    { value: '57/22.4', label: '57cm / 22.4"' },
    { value: '58/22.8', label: '58cm / 22.8"' },
    { value: '59/23.2', label: '59cm / 23.2"' },
    { value: '60/23.6', label: '60cm / 23.6"' },
    { value: '61/24', label: '61cm / 24"' },
    { value: '62/24.4', label: '62cm / 24.4"' },
    { value: '63/24.8', label: '63cm / 24.8"' },
    { value: '64/25.2', label: '64cm / 25.2"' },
    { value: '65/25.6', label: '65cm / 25.6"' },
    { value: '66/26', label: '66cm / 26"' },
    { value: '67/26.4', label: '67cm / 26.4"' },
    { value: '68/26.8', label: '68cm / 26.8"' },
    { value: '69/27.2', label: '69cm / 27.2"' },
    { value: '70/27.6', label: '70cm / 27.6"' },
    { value: '71/28', label: '71cm / 28"' },
    { value: '72/28.3', label: '72cm / 28.3"' },
    { value: '73/28.7', label: '73cm / 28.7"' },
    { value: '74/29.1', label: '74cm / 29.1"' },
    { value: '75/29.5', label: '75cm / 29.5"' },
    { value: '76/29.9', label: '76cm / 29.9"' },
    { value: '77/30.3', label: '77cm / 30.3"' },
    { value: '78/30.7', label: '78cm / 30.7"' },
    { value: '79/31.1', label: '79cm / 31.1"' },
    { value: '80/31.5', label: '80cm / 31.5"' },
    { value: '81/31.9', label: '81cm / 31.9"' },
    { value: '82/32.3', label: '82cm / 32.3"' },
    { value: '83/32.7', label: '83cm / 32.7"' },
    { value: '84/33.1', label: '84cm / 33.1"' },
    { value: '85/33.5', label: '85cm / 33.5"' },
    { value: '86/33.9', label: '86cm / 33.9"' },
    { value: '87/34.3', label: '87cm / 34.3"' },
    { value: '88/34.6', label: '88cm / 34.6"' },
    { value: '89/35', label: '89cm / 35"' },
    { value: '90/35.4', label: '90cm / 35.4"' },
    { value: '91/35.8', label: '91cm / 35.8"' },
    { value: '92/36.2', label: '92cm / 36.2"' },
    { value: '93/36.6', label: '93cm / 36.6"' },
    { value: '94/37', label: '94cm / 37"' },
    { value: '95/37.4', label: '95cm / 37.4"' },
    { value: '96/37.8', label: '96cm / 37.8"' },
    { value: '97/38.2', label: '97cm / 38.2"' },
    { value: '98/38.6', label: '98cm / 38.6"' },
    { value: '99/39', label: '99cm / 39"' },
    { value: '100/39.4', label: '100cm / 39.4"' },
    { value: '101/39.8', label: '101cm / 39.8"' },
    { value: '102/40.2', label: '102cm / 40.2"' },
    { value: '103/40.6', label: '103cm / 40.6"' },
    { value: '104/40.9', label: '104cm / 40.9"' },
    { value: '105/41.3', label: '105cm / 41.3"' },
    { value: '106/41.7', label: '106cm / 41.7"' },
    { value: '107/42.1', label: '107cm / 42.1"' },
    { value: '108/42.5', label: '108cm / 42.5"' },
    { value: '109/42.9', label: '109cm / 42.9"' },
    { value: '110/43.3', label: '110cm / 43.3"' },
    { value: '111/43.7', label: '111cm / 43.7"' },
    { value: '112/44.1', label: '112cm / 44.1"' },
    { value: '113/44.5', label: '113cm / 44.5"' },
    { value: '114/44.9', label: '114cm / 44.9"' },
    { value: '115/45.3', label: '115cm / 45.3"' },
    { value: '116/45.7', label: '116cm / 45.7"' },
    { value: '117/46.1', label: '117cm / 46.1"' },
    { value: '118/46.5', label: '118cm / 46.5"' },
    { value: '119/46.9', label: '119cm / 46.9"' },
    { value: '120/47.2', label: '120cm / 47.2"' },
    { value: '121/47.6', label: '121cm / 47.6"' },
    { value: '122/48', label: '122cm / 48"' },
    { value: '123/48.4', label: '123cm / 48.4"' },
    { value: '124/48.8', label: '124cm / 48.8"' },
    { value: '125/49.2', label: '125cm / 49.2"' },
    { value: '126/49.6', label: '126cm / 49.6"' },
    { value: '127/50', label: '127cm / 50"' },
    { value: '128/50.4', label: '128cm / 50.4"' },
    { value: '129/50.8', label: '129cm / 50.8"' },
    { value: '130/51.2', label: '130cm / 51.2"' },
    { value: '131/51.6', label: '131cm / 51.6"' },
    { value: '132/52', label: '132cm / 52"' },
    { value: '133/52.4', label: '133cm / 52.4"' },
    { value: '134/52.8', label: '134cm / 52.8"' },
    { value: '135/53.1', label: '135cm / 53.1"' },
    { value: '136/53.5', label: '136cm / 53.5"' },
    { value: '137/53.9', label: '137cm / 53.9"' },
    { value: '138/54.3', label: '138cm / 54.3"' },
    { value: '139/54.7', label: '139cm / 54.7"' },
    { value: '140/55.1', label: '140cm / 55.1"' },
    { value: '141/55.5', label: '141cm / 55.5"' },
    { value: '142/55.9', label: '142cm / 55.9"' },
    { value: '143/56.3', label: '143cm / 56.3"' },
    { value: '144/56.7', label: '144cm / 56.7"' },
    { value: '145/57.1', label: '145cm / 57.1"' },
    { value: '146/57.5', label: '146cm / 57.5"' },
    { value: '147/57.9', label: '147cm / 57.9"' },
    { value: '148/58.3', label: '148cm / 58.3"' },
    { value: '149/58.7', label: '149cm / 58.7"' },
    { value: '150/59.1', label: '150cm / 59.1"' },
    { value: '151/59.4', label: '151cm / 59.4"' },
    { value: '152/59.8', label: '152cm / 59.8"' },
    { value: '153/60.2', label: '153cm / 60.2"' },
    { value: '154/60.6', label: '154cm / 60.6"' },
    { value: '155/61', label: '155cm / 61"' },
    { value: '156/61.4', label: '156cm / 61.4"' },
    { value: '157/61.8', label: '157cm / 61.8"' },
    { value: '158/62.2', label: '158cm / 62.2"' },
    { value: '159/62.6', label: '159cm / 62.6"' },
    { value: '160/63', label: '160cm / 63"' },
    { value: '161/63.4', label: '161cm / 63.4"' },
    { value: '162/63.8', label: '162cm / 63.8"' },
    { value: '163/64.2', label: '163cm / 64.2"' },
    { value: '164/64.6', label: '164cm / 64.6"' },
    { value: '165/65', label: '165cm / 65"' },
    { value: '166/65.4', label: '166cm / 65.4"' },
    { value: '167/65.7', label: '167cm / 65.7"' },
    { value: '168/66.1', label: '168cm / 66.1"' },
    { value: '169/66.5', label: '169cm / 66.5"' },
    { value: '170/66.9', label: '170cm / 66.9"' },
    { value: '171/67.3', label: '171cm / 67.3"' },
    { value: '172/67.7', label: '172cm / 67.7"' },
    { value: '173/68.1', label: '173cm / 68.1"' },
    { value: '174/68.5', label: '174cm / 68.5"' },
    { value: '175/68.9', label: '175cm / 68.9"' },
    { value: '176/69.3', label: '176cm / 69.3"' },
    { value: '177/69.7', label: '177cm / 69.7"' },
    { value: '178/70.1', label: '178cm / 70.1"' },
    { value: '179/70.5', label: '179cm / 70.5"' },
    { value: '180/70.9', label: '180cm / 70.9"' },
    { value: '181/71.3', label: '181cm / 71.3"' },
    { value: '182/71.7', label: '182cm / 71.7"' },
    { value: '183/72', label: '183cm / 72"' },
    { value: '184/72.4', label: '184cm / 72.4"' },
    { value: '185/72.8', label: '185cm / 72.8"' },
    { value: '186/73.2', label: '186cm / 73.2"' },
    { value: '187/73.6', label: '187cm / 73.6"' },
    { value: '188/74', label: '188cm / 74"' },
    { value: '189/74.4', label: '189cm / 74.4"' },
    { value: '190/74.8', label: '190cm / 74.8"' },
    { value: '191/75.2', label: '191cm / 75.2"' },
    { value: '192/75.6', label: '192cm / 75.6"' },
    { value: '193/76', label: '193cm / 76"' },
    { value: '194/76.4', label: '194cm / 76.4"' },
    { value: '195/76.8', label: '195cm / 76.8"' },
    { value: '196/77.2', label: '196cm / 77.2"' },
    { value: '197/77.6', label: '197cm / 77.6"' },
    { value: '198/78', label: '198cm / 78"' },
    { value: '199/78.3', label: '199cm / 78.3"' },
    { value: '200/78.7', label: '200cm / 78.7"' }
  ],
  chest: [
    { value: '10/3.9', label: '10cm / 3.9"' },
    { value: '11/4.3', label: '11cm / 4.3"' },
    { value: '12/4.7', label: '12cm / 4.7"' },
    { value: '13/5.1', label: '13cm / 5.1"' },
    { value: '14/5.5', label: '14cm / 5.5"' },
    { value: '15/5.9', label: '15cm / 5.9"' },
    { value: '16/6.3', label: '16cm / 6.3"' },
    { value: '17/6.7', label: '17cm / 6.7"' },
    { value: '18/7.1', label: '18cm / 7.1"' },
    { value: '19/7.5', label: '19cm / 7.5"' },
    { value: '20/7.9', label: '20cm / 7.9"' },
    { value: '21/8.3', label: '21cm / 8.3"' },
    { value: '22/8.7', label: '22cm / 8.7"' },
    { value: '23/9.1', label: '23cm / 9.1"' },
    { value: '24/9.4', label: '24cm / 9.4"' },
    { value: '25/9.8', label: '25cm / 9.8"' },
    { value: '26/10.2', label: '26cm / 10.2"' },
    { value: '27/10.6', label: '27cm / 10.6"' },
    { value: '28/11', label: '28cm / 11"' },
    { value: '29/11.4', label: '29cm / 11.4"' },
    { value: '30/11.8', label: '30cm / 11.8"' },
    { value: '31/12.2', label: '31cm / 12.2"' },
    { value: '32/12.6', label: '32cm / 12.6"' },
    { value: '33/13', label: '33cm / 13"' },
    { value: '34/13.4', label: '34cm / 13.4"' },
    { value: '35/13.8', label: '35cm / 13.8"' },
    { value: '36/14.2', label: '36cm / 14.2"' },
    { value: '37/14.6', label: '37cm / 14.6"' },
    { value: '38/15', label: '38cm / 15"' },
    { value: '39/15.4', label: '39cm / 15.4"' },
    { value: '40/15.7', label: '40cm / 15.7"' },
    { value: '41/16.1', label: '41cm / 16.1"' },
    { value: '42/16.5', label: '42cm / 16.5"' },
    { value: '43/16.9', label: '43cm / 16.9"' },
    { value: '44/17.3', label: '44cm / 17.3"' },
    { value: '45/17.7', label: '45cm / 17.7"' },
    { value: '46/18.1', label: '46cm / 18.1"' },
    { value: '47/18.5', label: '47cm / 18.5"' },
    { value: '48/18.9', label: '48cm / 18.9"' },
    { value: '49/19.3', label: '49cm / 19.3"' },
    { value: '50/19.7', label: '50cm / 19.7"' },
    { value: '51/20.1', label: '51cm / 20.1"' },
    { value: '52/20.5', label: '52cm / 20.5"' },
    { value: '53/20.9', label: '53cm / 20.9"' },
    { value: '54/21.3', label: '54cm / 21.3"' },
    { value: '55/21.7', label: '55cm / 21.7"' },
    { value: '56/22', label: '56cm / 22"' },
    { value: '57/22.4', label: '57cm / 22.4"' },
    { value: '58/22.8', label: '58cm / 22.8"' },
    { value: '59/23.2', label: '59cm / 23.2"' },
    { value: '60/23.6', label: '60cm / 23.6"' },
    { value: '61/24', label: '61cm / 24"' },
    { value: '62/24.4', label: '62cm / 24.4"' },
    { value: '63/24.8', label: '63cm / 24.8"' },
    { value: '64/25.2', label: '64cm / 25.2"' },
    { value: '65/25.6', label: '65cm / 25.6"' },
    { value: '66/26', label: '66cm / 26"' },
    { value: '67/26.4', label: '67cm / 26.4"' },
    { value: '68/26.8', label: '68cm / 26.8"' },
    { value: '69/27.2', label: '69cm / 27.2"' },
    { value: '70/27.6', label: '70cm / 27.6"' },
    { value: '71/28', label: '71cm / 28"' },
    { value: '72/28.3', label: '72cm / 28.3"' },
    { value: '73/28.7', label: '73cm / 28.7"' },
    { value: '74/29.1', label: '74cm / 29.1"' },
    { value: '75/29.5', label: '75cm / 29.5"' },
    { value: '76/29.9', label: '76cm / 29.9"' },
    { value: '77/30.3', label: '77cm / 30.3"' },
    { value: '78/30.7', label: '78cm / 30.7"' },
    { value: '79/31.1', label: '79cm / 31.1"' },
    { value: '80/31.5', label: '80cm / 31.5"' },
    { value: '81/31.9', label: '81cm / 31.9"' },
    { value: '82/32.3', label: '82cm / 32.3"' },
    { value: '83/32.7', label: '83cm / 32.7"' },
    { value: '84/33.1', label: '84cm / 33.1"' },
    { value: '85/33.5', label: '85cm / 33.5"' },
    { value: '86/33.9', label: '86cm / 33.9"' },
    { value: '87/34.3', label: '87cm / 34.3"' },
    { value: '88/34.6', label: '88cm / 34.6"' },
    { value: '89/35', label: '89cm / 35"' },
    { value: '90/35.4', label: '90cm / 35.4"' },
    { value: '91/35.8', label: '91cm / 35.8"' },
    { value: '92/36.2', label: '92cm / 36.2"' },
    { value: '93/36.6', label: '93cm / 36.6"' },
    { value: '94/37', label: '94cm / 37"' },
    { value: '95/37.4', label: '95cm / 37.4"' },
    { value: '96/37.8', label: '96cm / 37.8"' },
    { value: '97/38.2', label: '97cm / 38.2"' },
    { value: '98/38.6', label: '98cm / 38.6"' },
    { value: '99/39', label: '99cm / 39"' },
    { value: '100/39.4', label: '100cm / 39.4"' },
    { value: '101/39.8', label: '101cm / 39.8"' },
    { value: '102/40.2', label: '102cm / 40.2"' },
    { value: '103/40.6', label: '103cm / 40.6"' },
    { value: '104/40.9', label: '104cm / 40.9"' },
    { value: '105/41.3', label: '105cm / 41.3"' },
    { value: '106/41.7', label: '106cm / 41.7"' },
    { value: '107/42.1', label: '107cm / 42.1"' },
    { value: '108/42.5', label: '108cm / 42.5"' },
    { value: '109/42.9', label: '109cm / 42.9"' },
    { value: '110/43.3', label: '110cm / 43.3"' },
    { value: '111/43.7', label: '111cm / 43.7"' },
    { value: '112/44.1', label: '112cm / 44.1"' },
    { value: '113/44.5', label: '113cm / 44.5"' },
    { value: '114/44.9', label: '114cm / 44.9"' },
    { value: '115/45.3', label: '115cm / 45.3"' },
    { value: '116/45.7', label: '116cm / 45.7"' },
    { value: '117/46.1', label: '117cm / 46.1"' },
    { value: '118/46.5', label: '118cm / 46.5"' },
    { value: '119/46.9', label: '119cm / 46.9"' },
    { value: '120/47.2', label: '120cm / 47.2"' },
    { value: '121/47.6', label: '121cm / 47.6"' },
    { value: '122/48', label: '122cm / 48"' },
    { value: '123/48.4', label: '123cm / 48.4"' },
    { value: '124/48.8', label: '124cm / 48.8"' },
    { value: '125/49.2', label: '125cm / 49.2"' },
    { value: '126/49.6', label: '126cm / 49.6"' },
    { value: '127/50', label: '127cm / 50"' },
    { value: '128/50.4', label: '128cm / 50.4"' },
    { value: '129/50.8', label: '129cm / 50.8"' },
    { value: '130/51.2', label: '130cm / 51.2"' },
    { value: '131/51.6', label: '131cm / 51.6"' },
    { value: '132/52', label: '132cm / 52"' },
    { value: '133/52.4', label: '133cm / 52.4"' },
    { value: '134/52.8', label: '134cm / 52.8"' },
    { value: '135/53.1', label: '135cm / 53.1"' },
    { value: '136/53.5', label: '136cm / 53.5"' },
    { value: '137/53.9', label: '137cm / 53.9"' },
    { value: '138/54.3', label: '138cm / 54.3"' },
    { value: '139/54.7', label: '139cm / 54.7"' },
    { value: '140/55.1', label: '140cm / 55.1"' },
    { value: '141/55.5', label: '141cm / 55.5"' },
    { value: '142/55.9', label: '142cm / 55.9"' },
    { value: '143/56.3', label: '143cm / 56.3"' },
    { value: '144/56.7', label: '144cm / 56.7"' },
    { value: '145/57.1', label: '145cm / 57.1"' },
    { value: '146/57.5', label: '146cm / 57.5"' },
    { value: '147/57.9', label: '147cm / 57.9"' },
    { value: '148/58.3', label: '148cm / 58.3"' },
    { value: '149/58.7', label: '149cm / 58.7"' },
    { value: '150/59.1', label: '150cm / 59.1"' },
    { value: '151/59.4', label: '151cm / 59.4"' },
    { value: '152/59.8', label: '152cm / 59.8"' },
    { value: '153/60.2', label: '153cm / 60.2"' },
    { value: '154/60.6', label: '154cm / 60.6"' },
    { value: '155/61', label: '155cm / 61"' },
    { value: '156/61.4', label: '156cm / 61.4"' },
    { value: '157/61.8', label: '157cm / 61.8"' },
    { value: '158/62.2', label: '158cm / 62.2"' },
    { value: '159/62.6', label: '159cm / 62.6"' },
    { value: '160/63', label: '160cm / 63"' },
    { value: '161/63.4', label: '161cm / 63.4"' },
    { value: '162/63.8', label: '162cm / 63.8"' },
    { value: '163/64.2', label: '163cm / 64.2"' },
    { value: '164/64.6', label: '164cm / 64.6"' },
    { value: '165/65', label: '165cm / 65"' },
    { value: '166/65.4', label: '166cm / 65.4"' },
    { value: '167/65.7', label: '167cm / 65.7"' },
    { value: '168/66.1', label: '168cm / 66.1"' },
    { value: '169/66.5', label: '169cm / 66.5"' },
    { value: '170/66.9', label: '170cm / 66.9"' },
    { value: '171/67.3', label: '171cm / 67.3"' },
    { value: '172/67.7', label: '172cm / 67.7"' },
    { value: '173/68.1', label: '173cm / 68.1"' },
    { value: '174/68.5', label: '174cm / 68.5"' },
    { value: '175/68.9', label: '175cm / 68.9"' },
    { value: '176/69.3', label: '176cm / 69.3"' },
    { value: '177/69.7', label: '177cm / 69.7"' },
    { value: '178/70.1', label: '178cm / 70.1"' },
    { value: '179/70.5', label: '179cm / 70.5"' },
    { value: '180/70.9', label: '180cm / 70.9"' },
    { value: '181/71.3', label: '181cm / 71.3"' },
    { value: '182/71.7', label: '182cm / 71.7"' },
    { value: '183/72', label: '183cm / 72"' },
    { value: '184/72.4', label: '184cm / 72.4"' },
    { value: '185/72.8', label: '185cm / 72.8"' },
    { value: '186/73.2', label: '186cm / 73.2"' },
    { value: '187/73.6', label: '187cm / 73.6"' },
    { value: '188/74', label: '188cm / 74"' },
    { value: '189/74.4', label: '189cm / 74.4"' },
    { value: '190/74.8', label: '190cm / 74.8"' },
    { value: '191/75.2', label: '191cm / 75.2"' },
    { value: '192/75.6', label: '192cm / 75.6"' },
    { value: '193/76', label: '193cm / 76"' },
    { value: '194/76.4', label: '194cm / 76.4"' },
    { value: '195/76.8', label: '195cm / 76.8"' },
    { value: '196/77.2', label: '196cm / 77.2"' },
    { value: '197/77.6', label: '197cm / 77.6"' },
    { value: '198/78', label: '198cm / 78"' },
    { value: '199/78.3', label: '199cm / 78.3"' },
    { value: '200/78.7', label: '200cm / 78.7"' }
  ],
  weight: [
    { value: '3/6.6', label: '3kg / 6.6lb' },
    { value: '4/8.8', label: '4kg / 8.8lb' },
    { value: '5/11', label: '5kg / 11lb' },
    { value: '6/13.2', label: '6kg / 13.2lb' },
    { value: '7/15.4', label: '7kg / 15.4lb' },
    { value: '8/17.6', label: '8kg / 17.6lb' },
    { value: '9/19.8', label: '9kg / 19.8lb' },
    { value: '10/22', label: '10kg / 22lb' },
    { value: '11/24.3', label: '11kg / 24.3lb' },
    { value: '12/26.5', label: '12kg / 26.5lb' },
    { value: '13/28.7', label: '13kg / 28.7lb' },
    { value: '14/30.9', label: '14kg / 30.9lb' },
    { value: '15/33.1', label: '15kg / 33.1lb' },
    { value: '16/35.3', label: '16kg / 35.3lb' },
    { value: '17/37.5', label: '17kg / 37.5lb' },
    { value: '18/39.7', label: '18kg / 39.7lb' },
    { value: '19/41.9', label: '19kg / 41.9lb' },
    { value: '20/44.1', label: '20kg / 44.1lb' },
    { value: '21/46.3', label: '21kg / 46.3lb' },
    { value: '22/48.5', label: '22kg / 48.5lb' },
    { value: '23/50.7', label: '23kg / 50.7lb' },
    { value: '24/52.9', label: '24kg / 52.9lb' },
    { value: '25/55.1', label: '25kg / 55.1lb' },
    { value: '26/57.3', label: '26kg / 57.3lb' },
    { value: '27/59.5', label: '27kg / 59.5lb' },
    { value: '28/61.7', label: '28kg / 61.7lb' },
    { value: '29/63.9', label: '29kg / 63.9lb' },
    { value: '30/66.1', label: '30kg / 66.1lb' },
    { value: '31/68.3', label: '31kg / 68.3lb' },
    { value: '32/70.5', label: '32kg / 70.5lb' },
    { value: '33/72.8', label: '33kg / 72.8lb' },
    { value: '34/75', label: '34kg / 75lb' },
    { value: '35/77.2', label: '35kg / 77.2lb' },
    { value: '36/79.4', label: '36kg / 79.4lb' },
    { value: '37/81.6', label: '37kg / 81.6lb' },
    { value: '38/83.8', label: '38kg / 83.8lb' },
    { value: '39/86', label: '39kg / 86lb' },
    { value: '40/88.2', label: '40kg / 88.2lb' },
    { value: '41/90.4', label: '41kg / 90.4lb' },
    { value: '42/92.6', label: '42kg / 92.6lb' },
    { value: '43/94.8', label: '43kg / 94.8lb' },
    { value: '44/97', label: '44kg / 97lb' },
    { value: '45/99.2', label: '45kg / 99.2lb' },
    { value: '46/101.4', label: '46kg / 101.4lb' },
    { value: '47/103.6', label: '47kg / 103.6lb' },
    { value: '48/105.8', label: '48kg / 105.8lb' },
    { value: '49/108', label: '49kg / 108lb' },
    { value: '50/110.2', label: '50kg / 110.2lb' },
    { value: '51/112.4', label: '51kg / 112.4lb' },
    { value: '52/114.6', label: '52kg / 114.6lb' },
    { value: '53/116.8', label: '53kg / 116.8lb' },
    { value: '54/119', label: '54kg / 119lb' },
    { value: '55/121.3', label: '55kg / 121.3lb' },
    { value: '56/123.5', label: '56kg / 123.5lb' },
    { value: '57/125.7', label: '57kg / 125.7lb' },
    { value: '58/127.9', label: '58kg / 127.9lb' },
    { value: '59/130.1', label: '59kg / 130.1lb' },
    { value: '60/132.3', label: '60kg / 132.3lb' },
    { value: '61/134.5', label: '61kg / 134.5lb' },
    { value: '62/136.7', label: '62kg / 136.7lb' },
    { value: '63/138.9', label: '63kg / 138.9lb' },
    { value: '64/141.1', label: '64kg / 141.1lb' },
    { value: '65/143.3', label: '65kg / 143.3lb' },
    { value: '66/145.5', label: '66kg / 145.5lb' },
    { value: '67/147.7', label: '67kg / 147.7lb' },
    { value: '68/149.9', label: '68kg / 149.9lb' },
    { value: '69/152.1', label: '69kg / 152.1lb' },
    { value: '70/154.3', label: '70kg / 154.3lb' },
    { value: '71/156.5', label: '71kg / 156.5lb' },
    { value: '72/158.7', label: '72kg / 158.7lb' },
    { value: '73/160.9', label: '73kg / 160.9lb' },
    { value: '74/163.1', label: '74kg / 163.1lb' },
    { value: '75/165.3', label: '75kg / 165.3lb' },
    { value: '76/167.6', label: '76kg / 167.6lb' },
    { value: '77/169.8', label: '77kg / 169.8lb' },
    { value: '78/172', label: '78kg / 172lb' },
    { value: '79/174.2', label: '79kg / 174.2lb' },
    { value: '80/176.4', label: '80kg / 176.4lb' },
    { value: '81/178.6', label: '81kg / 178.6lb' },
    { value: '82/180.8', label: '82kg / 180.8lb' },
    { value: '83/183', label: '83kg / 183lb' },
    { value: '84/185.2', label: '84kg / 185.2lb' },
    { value: '85/187.4', label: '85kg / 187.4lb' },
    { value: '86/189.6', label: '86kg / 189.6lb' },
    { value: '87/191.8', label: '87kg / 191.8lb' },
    { value: '88/194', label: '88kg / 194lb' },
    { value: '89/196.2', label: '89kg / 196.2lb' },
    { value: '90/198.4', label: '90kg / 198.4lb' },
    { value: '91/200.6', label: '91kg / 200.6lb' },
    { value: '92/202.8', label: '92kg / 202.8lb' },
    { value: '93/205', label: '93kg / 205lb' },
    { value: '94/207.2', label: '94kg / 207.2lb' },
    { value: '95/209.4', label: '95kg / 209.4lb' },
    { value: '96/211.6', label: '96kg / 211.6lb' },
    { value: '97/213.8', label: '97kg / 213.8lb' },
    { value: '98/216.1', label: '98kg / 216.1lb' },
    { value: '99/218.3', label: '99kg / 218.3lb' },
    { value: '100/220.5', label: '100kg / 220.5lb' },
    { value: '101/222.7', label: '101kg / 222.7lb' },
    { value: '102/224.9', label: '102kg / 224.9lb' },
    { value: '103/227.1', label: '103kg / 227.1lb' },
    { value: '104/229.3', label: '104kg / 229.3lb' },
    { value: '105/231.5', label: '105kg / 231.5lb' },
    { value: '106/233.7', label: '106kg / 233.7lb' },
    { value: '107/235.9', label: '107kg / 235.9lb' },
    { value: '108/238.1', label: '108kg / 238.1lb' },
    { value: '109/240.3', label: '109kg / 240.3lb' },
    { value: '110/242.5', label: '110kg / 242.5lb' },
    { value: '111/244.7', label: '111kg / 244.7lb' },
    { value: '112/246.9', label: '112kg / 246.9lb' },
    { value: '113/249.1', label: '113kg / 249.1lb' },
    { value: '114/251.3', label: '114kg / 251.3lb' },
    { value: '115/253.5', label: '115kg / 253.5lb' },
    { value: '116/255.7', label: '116kg / 255.7lb' },
    { value: '117/257.9', label: '117kg / 257.9lb' },
    { value: '118/260.1', label: '118kg / 260.1lb' },
    { value: '119/262.4', label: '119kg / 262.4lb' },
    { value: '120/264.6', label: '120kg / 264.6lb' },
    { value: '121/266.8', label: '121kg / 266.8lb' },
    { value: '122/269', label: '122kg / 269lb' },
    { value: '123/271.2', label: '123kg / 271.2lb' },
    { value: '124/273.4', label: '124kg / 273.4lb' },
    { value: '125/275.6', label: '125kg / 275.6lb' },
    { value: '126/277.8', label: '126kg / 277.8lb' },
    { value: '127/280', label: '127kg / 280lb' },
    { value: '128/282.2', label: '128kg / 282.2lb' },
    { value: '129/284.4', label: '129kg / 284.4lb' },
    { value: '130/286.6', label: '130kg / 286.6lb' },
    { value: '131/288.8', label: '131kg / 288.8lb' },
    { value: '132/291', label: '132kg / 291lb' },
    { value: '133/293.2', label: '133kg / 293.2lb' },
    { value: '134/295.4', label: '134kg / 295.4lb' },
    { value: '135/297.6', label: '135kg / 297.6lb' },
    { value: '136/299.8', label: '136kg / 299.8lb' },
    { value: '137/302', label: '137kg / 302lb' },
    { value: '138/304.2', label: '138kg / 304.2lb' },
    { value: '139/306.4', label: '139kg / 306.4lb' },
    { value: '140/308.6', label: '140kg / 308.6lb' },
    { value: '141/310.9', label: '141kg / 310.9lb' },
    { value: '142/313.1', label: '142kg / 313.1lb' },
    { value: '143/315.3', label: '143kg / 315.3lb' },
    { value: '144/317.5', label: '144kg / 317.5lb' },
    { value: '145/319.7', label: '145kg / 319.7lb' },
    { value: '146/321.9', label: '146kg / 321.9lb' },
    { value: '147/324.1', label: '147kg / 324.1lb' },
    { value: '148/326.3', label: '148kg / 326.3lb' },
    { value: '149/328.5', label: '149kg / 328.5lb' },
    { value: '150/330.7', label: '150kg / 330.7lb' },
    { value: '151/332.9', label: '151kg / 332.9lb' },
    { value: '152/335.1', label: '152kg / 335.1lb' },
    { value: '153/337.3', label: '153kg / 337.3lb' },
    { value: '154/339.5', label: '154kg / 339.5lb' },
    { value: '155/341.7', label: '155kg / 341.7lb' },
    { value: '156/343.9', label: '156kg / 343.9lb' },
    { value: '157/346.1', label: '157kg / 346.1lb' },
    { value: '158/348.3', label: '158kg / 348.3lb' },
    { value: '159/350.5', label: '159kg / 350.5lb' },
    { value: '160/352.7', label: '160kg / 352.7lb' },
    { value: '161/354.9', label: '161kg / 354.9lb' },
    { value: '162/357.1', label: '162kg / 357.1lb' },
    { value: '163/359.4', label: '163kg / 359.4lb' },
    { value: '164/361.6', label: '164kg / 361.6lb' },
    { value: '165/363.8', label: '165kg / 363.8lb' },
    { value: '166/366', label: '166kg / 366lb' },
    { value: '167/368.2', label: '167kg / 368.2lb' },
    { value: '168/370.4', label: '168kg / 370.4lb' },
    { value: '169/372.6', label: '169kg / 372.6lb' },
    { value: '170/374.8', label: '170kg / 374.8lb' },
    { value: '171/377', label: '171kg / 377lb' },
    { value: '172/379.2', label: '172kg / 379.2lb' },
    { value: '173/381.4', label: '173kg / 381.4lb' },
    { value: '174/383.6', label: '174kg / 383.6lb' },
    { value: '175/385.8', label: '175kg / 385.8lb' },
    { value: '176/388', label: '176kg / 388lb' },
    { value: '177/390.2', label: '177kg / 390.2lb' },
    { value: '178/392.4', label: '178kg / 392.4lb' },
    { value: '179/394.6', label: '179kg / 394.6lb' },
    { value: '180/396.8', label: '180kg / 396.8lb' },
    { value: '181/399', label: '181kg / 399lb' },
    { value: '182/401.2', label: '182kg / 401.2lb' },
    { value: '183/403.4', label: '183kg / 403.4lb' },
    { value: '184/405.7', label: '184kg / 405.7lb' },
    { value: '185/407.9', label: '185kg / 407.9lb' },
    { value: '186/410.1', label: '186kg / 410.1lb' },
    { value: '187/412.3', label: '187kg / 412.3lb' },
    { value: '188/414.5', label: '188kg / 414.5lb' },
    { value: '189/416.7', label: '189kg / 416.7lb' },
    { value: '190/418.9', label: '190kg / 418.9lb' },
    { value: '191/421.1', label: '191kg / 421.1lb' },
    { value: '192/423.3', label: '192kg / 423.3lb' },
    { value: '193/425.5', label: '193kg / 425.5lb' },
    { value: '194/427.7', label: '194kg / 427.7lb' },
    { value: '195/429.9', label: '195kg / 429.9lb' },
    { value: '196/432.1', label: '196kg / 432.1lb' },
    { value: '197/434.3', label: '197kg / 434.3lb' },
    { value: '198/436.5', label: '198kg / 436.5lb' },
    { value: '199/438.7', label: '199kg / 438.7lb' },
    { value: '200/440.9', label: '200kg / 440.9lb' }
  ],
  jeans: [
    { value: '34', label: '34' },
    { value: '34.5', label: '34.5' },
    { value: '35', label: '35' },
    { value: '35.5', label: '35.5' },
    { value: '36', label: '36' },
    { value: '36.5', label: '36.5' },
    { value: '37', label: '37' },
    { value: '37.5', label: '37.5' },
    { value: '38', label: '38' },
    { value: '38.5', label: '38.5' },
    { value: '39', label: '39' },
    { value: '39.5', label: '39.5' },
    { value: '40', label: '40' },
    { value: '40.5', label: '40.5' },
    { value: '41', label: '41' },
    { value: '41.5', label: '41.5' },
    { value: '42', label: '42' },
    { value: '42.5', label: '42.5' },
    { value: '43', label: '43' },
    { value: '43.5', label: '43.5' },
    { value: '44', label: '44' },
    { value: '44.5', label: '44.5' },
    { value: '45', label: '45' },
    { value: '45.5', label: '45.5' },
    { value: '46', label: '46' },
    { value: '46.5', label: '46.5' },
    { value: '47', label: '47' },
    { value: '47.5', label: '47.5' },
    { value: '48', label: '48' },
    { value: '48.5', label: '48.5' },
    { value: '49', label: '49' },
    { value: '49.5', label: '49.5' },
    { value: '50', label: '50' },
    { value: '50.5', label: '50.5' },
    { value: '51', label: '51' },
    { value: '51.5', label: '51.5' },
    { value: '52', label: '52' },
    { value: '52.5', label: '52.5' },
    { value: '53', label: '53' },
    { value: '53.5', label: '53.5' },
    { value: '54', label: '54' },
    { value: '54.5', label: '54.5' },
    { value: '55', label: '55' },
    { value: '55.5', label: '55.5' },
    { value: '56', label: '56' },
    { value: '56.5', label: '56.5' },
    { value: '57', label: '57' },
    { value: '57.5', label: '57.5' },
    { value: '58', label: '58' },
    { value: '58.5', label: '58.5' },
    { value: '59', label: '59' },
    { value: '59.5', label: '59.5' },
    { value: '60', label: '60' }
  ],
  shoes: [
    { value: '1', label: '1' },
    { value: '1.5', label: '1.5' },
    { value: '2', label: '2' },
    { value: '2.5', label: '2.5' },
    { value: '3', label: '3' },
    { value: '3.5', label: '3.5' },
    { value: '4', label: '4' },
    { value: '4.5', label: '4.5' },
    { value: '5', label: '5' },
    { value: '5.5', label: '5.5' },
    { value: '6', label: '6' },
    { value: '6.5', label: '6.5' },
    { value: '7', label: '7' },
    { value: '7.5', label: '7.5' },
    { value: '8', label: '8' },
    { value: '8.5', label: '8.5' },
    { value: '9', label: '9' },
    { value: '9.5', label: '9.5' },
    { value: '10', label: '10' },
    { value: '10.5', label: '10.5' },
    { value: '11', label: '11' },
    { value: '11.5', label: '11.5' },
    { value: '12', label: '12' },
    { value: '12.5', label: '12.5' },
    { value: '13', label: '13' },
    { value: '13.5', label: '13.5' },
    { value: '14', label: '14' },
    { value: '14.5', label: '14.5' },
    { value: '15', label: '15' },
    { value: '15.5', label: '15.5' },
    { value: '16', label: '16' },
    { value: '16.5', label: '16.5' },
    { value: '17', label: '17' },
    { value: '17.5', label: '17.5' },
    { value: '18', label: '18' },
    { value: '18.5', label: '18.5' },
    { value: '19', label: '19' },
    { value: '19.5', label: '19.5' },
    { value: '20', label: '20' },
    { value: '20.5', label: '20.5' },
    { value: '21', label: '21' },
    { value: '21.5', label: '21.5' },
    { value: '22', label: '22' },
    { value: '22.5', label: '22.5' },
    { value: '23', label: '23' },
    { value: '23.5', label: '23.5' },
    { value: '24', label: '24' },
    { value: '24.5', label: '24.5' },
    { value: '25', label: '25' },
    { value: '25.5', label: '25.5' },
    { value: '26', label: '26' },
    { value: '26.5', label: '26.5' },
    { value: '27', label: '27' },
    { value: '27.5', label: '27.5' },
    { value: '28', label: '28' },
    { value: '28.5', label: '28.5' },
    { value: '29', label: '29' },
    { value: '29.5', label: '29.5' },
    { value: '30', label: '30' },
    { value: '30.5', label: '30.5' },
    { value: '31', label: '31' },
    { value: '31.5', label: '31.5' },
    { value: '32', label: '32' },
    { value: '32.5', label: '32.5' },
    { value: '33', label: '33' },
    { value: '33.5', label: '33.5' },
    { value: '34', label: '34' },
    { value: '34.5', label: '34.5' },
    { value: '35', label: '35' },
    { value: '35.5', label: '35.5' },
    { value: '36', label: '36' },
    { value: '36.5', label: '36.5' },
    { value: '37', label: '37' },
    { value: '37.5', label: '37.5' },
    { value: '38', label: '38' },
    { value: '38.5', label: '38.5' },
    { value: '39', label: '39' },
    { value: '39.5', label: '39.5' },
    { value: '40', label: '40' },
    { value: '40.5', label: '40.5' },
    { value: '41', label: '41' },
    { value: '41.5', label: '41.5' },
    { value: '42', label: '42' },
    { value: '42.5', label: '42.5' },
    { value: '43', label: '43' },
    { value: '43.5', label: '43.5' },
    { value: '44', label: '44' },
    { value: '44.5', label: '44.5' },
    { value: '45', label: '45' },
    { value: '45.5', label: '45.5' },
    { value: '46', label: '46' },
    { value: '46.5', label: '46.5' },
    { value: '47', label: '47' },
    { value: '47.5', label: '47.5' },
    { value: '48', label: '48' },
    { value: '48.5', label: '48.5' },
    { value: '49', label: '49' },
    { value: '49.5', label: '49.5' },
    { value: '50', label: '50' },
    { value: '50.5', label: '50.5' },
    { value: '51', label: '51' },
    { value: '51.5', label: '51.5' },
    { value: '52', label: '52' },
    { value: '52.5', label: '52.5' },
    { value: '53', label: '53' },
    { value: '53.5', label: '53.5' },
    { value: '54', label: '54' },
    { value: '54.5', label: '54.5' },
    { value: '55', label: '55' },
    { value: '55.5', label: '55.5' },
    { value: '56', label: '56' },
    { value: '56.5', label: '56.5' },
    { value: '57', label: '57' },
    { value: '57.5', label: '57.5' },
    { value: '58', label: '58' },
    { value: '58.5', label: '58.5' },
    { value: '59', label: '59' },
    { value: '59.5', label: '59.5' },
    { value: '60', label: '60' }
  ],
  measurements_type: [
    { value: 'EUR', label: 'EUR' },
    { value: 'BR', label: 'BR' },
    { value: 'MX', label: 'MX' },
    { value: 'US', label: 'US' }
  ],
  hair: [
    'Hairless',
    'Ash Blonde',
    'Auburn',
    'Black',
    'Blonde',
    'Brown',
    'Brown Coffee',
    'Cendre',
    'Chestnut',
    'Dark',
    'Dark Black',
    'Dark Blonde',
    'Dark Brown',
    'Grey',
    'Grey Black',
    'Hazel',
    'Light Blonde',
    'Light Brown',
    'Medium Blonde',
    'Platinum Blonde',
    'Red',
    'Red Blonde',
    'Red Brown',
    'Salt and Pepper',
    'Strawberry Blonde'
  ],
  eyes: [
    'Amber',
    'Black',
    'Blue',
    'Blue Green',
    'Blue Grey',
    'Brown',
    'Brown Coffee',
    'Dark Brown',
    'Green',
    'Green Brown',
    'Green Grey',
    'Green Olive',
    'Grey',
    'Hazel',
    'Honey',
    'Light Blue',
    'Light Brown'
  ],
  civil_state: {
    0: 'Sem informação',
    1: 'Solteiro(a)',
    2: 'Casado(a)',
    3: 'Divorciado(a)',
    4: 'Viúvo(a)'
  },
  type_account: [
    { value: 1, label: 'Conta corrente' },
    { value: 2, label: 'Conta poupança' }
  ]
}

export default options



// WEBPACK FOOTER //
// ./src/assets/options/options.js